import * as React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import PPIListComponent from './ppi-list-component';
import * as actions from '../../../actions';
import PPIService from '../../../service/sfp/ppi-service';

class PPIListContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			loading: true,
			ppis: []
		}
	}

	componentDidMount() {
		this.props.actions.setPageTitle("PPI");

		PPIService.findAllPPIs()
			.then(response => {
				this.setState({loading: false, ppi: response});
			}, error => {
				this.props.actions.throwError(error);
				this.setState({error, loading: false});
			});
	}

	render() {
		return (
			<PPIListComponent
				error={this.state.error}
				loading={this.state.loading}
				ppis={this.state.ppis} />
		);
	}
}

const mapStateToProps = state => state;
const mapDispatchToProps = (dispatch) => (
	{actions: bindActionCreators(actions, dispatch)}
);

export default connect(mapStateToProps, mapDispatchToProps)(PPIListContainer);



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-list/ppi-list-container.js